import type { FaireProductEntity } from "../../entity_types/product";

export const p_3hfym99qqa: FaireProductEntity = {
  token: "p_3hfym99qqa",
  type: "product",
  name: "Real Toddlers of Custom Town T-Shirt",
  brandToken: "b_bqub3wwmta",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/77f43c6cf11d8d7f23f98f1e8f72ec8b3303be5269ae246bba7b498a91ff87eb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5588611021a9b0e93ae7d8c1a124046357eed3232e069069dbf14ba066725ba1.png",
    "https://cdn.faire.com/fastly/ad5f31a9f991652a6b52e8d2c36246967aab7b3a1587dda24052d3ce9bb459dc.png",
    "https://cdn.faire.com/fastly/1e3f949f6826199e3a75addb2c79aafa2444ea5d147a40c336a8847c40dd7eae.png",
    "https://cdn.faire.com/fastly/17d034860dd817a73691d5b9fbacbc2a5b313e0441bba60d794aa27d2f1e4fdc.jpeg",
    "https://cdn.faire.com/fastly/9958fffbfcd034e65c4f1632cd549254bec6762eb4a8cf5564244b55cffb671a.jpeg",
  ],
  priceDollars: 15.94,
  description:
    "The Real Toddlers of..(Custom Town) T-shirt is such a cute design.  The Real Housewives have toddlers, so let's show them off with this adorable design. \n\nWe use either Rabbit Skin, Gildan, or Bella Canvas t-shirts.  The brand depends on the availability of the color chosen.  The shirts are made of soft ring-spun cotton with a tear-away label and unisex fit.  \n\nKeep in mind that there are always slight variations in sizing and colors.\n\nThe shirts are made using either heat transfer vinyl or DTF transfer that we adhere to your shirt with a heat press machine.\n\nCare Instructions (a care instruction card is also included with your purchase):  \n-Machine wash cold, turning the garment inside out\n-Tumble dry low or hang to dry\n-DO NOT IRON OVER THE DESIGN\n\nIf you have any questions, please do not hesitate to message me!",
  tags: [],
  msrpDollars: 31.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:19.517Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
